import * as yup from "yup";

export const getLoginValidationSchema = yup.object().shape({
  login: yup.string().required("requiredLogin"),
  password: yup.string().required("requiredPassword"),
});
